
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"23","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.643 11.07a1.387 1.387 0 010 1.86c-1.457 1.567-4.773 4.619-8.643 4.619-3.87 0-7.186-3.052-8.643-4.62a1.387 1.387 0 010-1.859C2.814 9.503 6.13 6.451 10 6.451c3.87 0 7.186 3.052 8.643 4.62z","stroke":"#748190","stroke-width":"1.387","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.001 14.774a2.775 2.775 0 100-5.549 2.775 2.775 0 000 5.55z","stroke":"#748190","stroke-width":"1.387","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    